import { GridColDef } from "@mui/x-data-grid";
import PartNumberCell from "../../componentes/fluxo-engenheiro/Requests/columns/partNumberCell";
import formatDateGrid from "../formatDateGrid";

export const buildAprovadorColumns = ({
  idField = "id",
  showCrea = false,
  showActions = false,
  renderActions,
}: {
  idField?: string;
  showCrea?: boolean;
  showActions?: boolean;
  renderActions?: (row: any) => React.ReactNode;
}): GridColDef[] => {
  const columns: GridColDef[] = [
    {
      field: idField,
      headerClassName: "header-table",
      renderHeader: () => <b className="partNumberColluns">classificationId</b>,
      renderCell: (params) => (
        <p className="partNumberColluns">{params.value}</p>
      ),
      flex: 1,
      headerAlign: "right",
      align: "right",
    },
    {
      field: "email",
      headerClassName: "header-table",
      renderHeader: () => <b className="partNumberColluns">E-mail</b>,
      renderCell: (params) => <PartNumberCell value={params.value as string} />,
      flex: 1.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "division",
      headerClassName: "header-table",
      renderHeader: () => <b className="descriptionColluns">Divisão</b>,
      renderCell: (params) => params.value ?? "N/A",
      flex: 1,
    },
    {
      field: "updatedAt",
      headerClassName: "header-table",
      renderHeader: () => <b className="flagColluns">Criação Cadastro</b>,
      renderCell: (params) =>
        params.value ? formatDateGrid(params.value) : "N/A",
      flex: 1,
    },
  ];

  if (showCrea) {
    columns.push({
      field: "crea",
      headerClassName: "header-table",
      renderHeader: () => <b className="flagColluns">CREA</b>,
      flex: 1,
    });
  }
  
  if (showActions && renderActions) {
    columns.push({
      field: "acoes",
      headerClassName: "header-table",
      renderHeader: () => <b className="title-table">Ações</b>,
      flex: 0.7,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => renderActions(params.row),
    });
  }

  return columns;
};
